import React, { useEffect, useState } from "react";
import ImageEditor from "@toast-ui/react-image-editor";
import "tui-image-editor/dist/tui-image-editor.css";
import "./ceoTheme.css";
import { ceoTheme } from "./Theme";

export default function UnwrappedImageEditor(props) {
    const [content, setContent] = useState(props.content);
    const [editorRef, setEditorRef] = useState(props.editorRef);

    useEffect(() => {
        setContent(props.content);
    }, [props.content]);
    useEffect(() => {
        setEditorRef(props.editorRef);
    }, [props.editorRef]);

    if (!content.uuid || !content.attachment) {
        return null;
    }

    return (
        <div>
            <ImageEditor
                ref={editorRef}
                includeUI={{
                    loadImage: {
                        path: content.attachment.public_url,
                        name: content.slug,
                    },
                    theme: ceoTheme,
                    menu: [
                        "crop",
                        "flip",
                        "rotate",
                        "draw",
                        "shape",
                        "text",
                        "filter",
                    ],
                    uiSize: {
                        height: `calc(100vh - 200px)`,
                    },
                    menuBarPosition: "bottom",
                }}
                cssMaxHeight={1150}
                cssMaxWidth={1150}
                selectionStyle={{
                    cornerSize: 20,
                    rotatingPointOffset: 70,
                }}
                usageStatistics={true}
            />
        </div>
    );
}
